export default {
    name: 'InvalidLink'
}